import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import ChartHeader from 'components/charts/ChartHeader';
import PieChartV2 from 'components/charts/chartJS/PieChart';
import { chartColors } from 'components/charts/chartJS/utils';
import DynamicList from 'components/list/DynamicList';
import { FilterType } from 'components/list/DynamicListFilterUtils';

import useFetchAndParseOnView from 'hooks/useFetchAndParseOnView';

import { ADMIN, ENUMS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

import * as S from './CohortAnalysis.styled';

const CohortIntegratorAnalysis = () => {
	const columns = useMemo(
		() => [
			{
				Header: 'cohortIntg',
				accessor: 'cohortIntg',
				filterType: FilterType.enum,
				enumName: ENUMS.COHORTS
			},
			{
				Header: 'clientType',
				accessor: 'clientType',
				filterType: FilterType.string
			},
			{
				Header: 'numberOfClients',
				accessor: 'numberOfClient',
				filterType: FilterType.number
			}
		],
		[]
	);

	return (
		<S.Container>
			<S.DynamicListWrapper>
				<DynamicList
					id={DYNAMICLISTS.COHORT_INTEGRATOR_ANALYSIS}
					columns={columns}
					fetchUrl={ADMIN.CONFIGURATION.GET_COHORT_INTEGRATOR_ANALYSIS}
					actionObjectType={ACTION_OBJECT_TYPES.ADMIN}
				/>
			</S.DynamicListWrapper>
			<CohortIntegratorDistribution />
		</S.Container>
	);
};

const CohortIntegratorDistribution = () => {
	const afterFetch = (data) => {
		const labels = data.map((item) => item.label);
		const datasets = [{ data: data.map((item) => item.value), ...chartColors }];
		return { labels, datasets };
	};

	const { ref, data, loading } = useFetchAndParseOnView({
		url: ADMIN.CONFIGURATION.GET_COHORT_INTEGRATOR_DISTRIBUTION,
		parseData: afterFetch
	});

	return (
		<S.ChartCard ref={ref}>
			<ChartHeader title={'cohortAggregatorDistribution'} />
			<PieChartV2 data={data} loading={loading} />
		</S.ChartCard>
	);
};

export default CohortIntegratorAnalysis;
